"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAllergiesAndSensitivities = createAllergiesAndSensitivities;
const events_1 = require("../../../events");
const allergiesAndSensitivities_1 = require("../../../forms/ktx/transplantation-screening/medical-history/risks/allergiesAndSensitivities");
const queries_1 = require("../queries");
const messages = {
    foodAllergy: {
        id: "ktx.dashboard.risks.food_allergy",
        defaultMessage: "Ételallergia"
    },
    medicineSensitivity: {
        id: "ktx.dashboard.risks.medicine_sensitivity",
        defaultMessage: "Gyógyszerérzékenység"
    },
    otherAllergy: {
        id: "ktx.dashboard.risks.other_allergy",
        defaultMessage: "Egyéb allergia"
    }
};
function createAllergiesAndSensitivities({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.medicalHistoryQueries.allergiesAndSensitivities);
    if (event === undefined) {
        return [undefined];
    }
    const { origin, value: { medicineSensitivity: sensitivities, foodAllergy: foodAllergies, otherAllergy: otherAllergies } } = event;
    const sensitivityItems = sensitivities
        ? sensitivities.map(sensitivity => {
            if (sensitivity ===
                allergiesAndSensitivities_1.MedicineSensitivity.MEDICINE_SENSITIVITY_OTHER) {
                return {
                    type: "list-item",
                    value: event.value.medicineSensitivityOther
                };
            }
            const formattedValue = formatMessageMap(allergiesAndSensitivities_1.medicineSensitivityMessages, sensitivity);
            return {
                type: "list-item",
                value: formattedValue
            };
        })
        : [];
    const foodAllergyItems = foodAllergies
        ? foodAllergies.map(allergy => {
            if (allergy === allergiesAndSensitivities_1.FoodAllergy.FOOD_ALLERGY_OTHER) {
                return {
                    type: "list-item",
                    value: event.value.foodAllergyOther
                };
            }
            const formattedValue = formatMessageMap(allergiesAndSensitivities_1.foodAllergyMessages, allergy);
            return {
                type: "list-item",
                value: formattedValue
            };
        })
        : [];
    const otherAllergyItems = otherAllergies
        ? otherAllergies.map(allergy => {
            const formattedValue = formatMessageMap(allergiesAndSensitivities_1.otherAllergyMessages, allergy);
            return {
                type: "list-item",
                value: formattedValue
            };
        })
        : [];
    const ret = [];
    if (sensitivityItems.length > 0) {
        ret.push({
            type: "list",
            attachments: (0, events_1.mapEventsToAttachments)(event),
            origin,
            label: formatMessage(messages.medicineSensitivity),
            items: sensitivityItems
        });
    }
    if (foodAllergyItems.length > 0) {
        ret.push({
            type: "list",
            attachments: (0, events_1.mapEventsToAttachments)(event),
            origin,
            label: formatMessage(messages.foodAllergy),
            items: foodAllergyItems
        });
    }
    if (otherAllergyItems.length > 0) {
        ret.push({
            type: "list",
            attachments: (0, events_1.mapEventsToAttachments)(event),
            origin,
            label: formatMessage(messages.otherAllergy),
            items: otherAllergyItems
        });
    }
    return ret;
}
